import React, { Children } from "react";
import { Field } from "redux-form";
import { FormField } from "admin-on-rest";
import { Card, CardHeader } from "material-ui/Card";
import { Flex, Box } from "rebass";
import { orange500, cyan500 } from "material-ui/styles/colors";
import IconHelp from "material-ui/svg-icons/action/help-outline";
import IconButton from "material-ui/IconButton";
import ImageEye from "material-ui/svg-icons/image/remove-red-eye";
import { TextField } from "redux-form-material-ui";
import ReactTooltip from "react-tooltip";
import { checkNumber } from "./utilsMarketer";

export const checkSubLabel = (label, labelContains) => {
  if (label && labelContains) {
    return label.includes(labelContains);
  }
  return false;
};

export const DetailsField = (
  children,
  record,
  resource,
  basePath,
  translate,
  updateField
) => {
  return (
    <Card containerStyle={{ padding: 16, marginBottom: 16 }}>
      <CardHeader
        title={translate("resources.marketers.fields.title")}
        style={{ padding: 0 }}
      />
      <div>
        {Children.map(
          children,
          (input) =>
            input &&
            checkSubLabel(input.props.label, "fields") && (
              <div
                key={input.props.source}
                className={`aor-input-${input.props.source}`}
                style={input.props.style}
              >
                <FormField
                  input={input}
                  resource={resource}
                  record={record}
                  basePath={basePath}
                  updateField={updateField}
                />
              </div>
            )
        )}
      </div>
    </Card>
  );
};

export const BanksField = (children, record, resource, basePath, translate) => (
  <Card containerStyle={{ padding: 16, marginBottom: 16 }}>
    <CardHeader
      title={translate("resources.marketers.banks.title")}
      style={{ padding: 0 }}
    />
    <div>
      {Children.map(
        children,
        (input) =>
          input &&
          checkSubLabel(input.props.label, "banks") && (
            <div
              key={input.props.source}
              className={`aor-input-${input.props.source}`}
              style={input.props.style}
            >
              <FormField
                input={input}
                resource={resource}
                record={record}
                basePath={basePath}
              />
            </div>
          )
      )}
    </div>
  </Card>
);

export const SocialField = (
  children,
  record,
  resource,
  basePath,
  translate,
  allProps
) => (
  <Card containerStyle={{ padding: 16, marginBottom: 16 }}>
    <CardHeader
      title={translate("resources.marketers.social.title")}
      style={{ padding: 0 }}
    />
    <div>
      {Children.map(
        children,
        (input) =>
          input &&
          checkSubLabel(input.props.label, "social") && (
            <div
              key={input.props.source}
              className={`aor-input-${input.props.source}`}
              style={input.props.style}
            >
              <Flex wrap direction="row" align="center">
                <Box>
                  <FormField
                    input={input}
                    resource={resource}
                    record={record}
                    basePath={basePath}
                  />
                  <span
                    data-tip=""
                    data-for={`${input.props.source}slugtooltip`}
                  >
                    <IconHelp style={{ marginLeft: 16 }} color={orange500} />
                  </span>
                  <IconButton
                    iconStyle={styles.mediumIcon}
                    style={styles.medium}
                    href={linkToSocial(input.props.source, allProps)}
                    target="_blank"
                  >
                    <ImageEye />
                  </IconButton>
                </Box>
                <ReactTooltip
                  id={`${input.props.source}slugtooltip`}
                  type="error"
                  aria-haspopup="true"
                  place="top"
                >
                  <span>{checkMessageField(input.props.source)}</span>
                </ReactTooltip>
                <Box pl={[0, 2]}>
                  <Field
                    name={checkNameField(input.props.source)}
                    component={TextField}
                    type="number"
                    parse={(v) => checkNumber(v)}
                    floatingLabelText="Followers"
                  />
                </Box>
              </Flex>
            </div>
          )
      )}
    </div>
  </Card>
);

export const CategoryField = (
  children,
  record,
  resource,
  basePath,
  translate
) => (
  <Card containerStyle={{ padding: 16, marginBottom: 16 }}>
    <CardHeader
      title={translate("resources.marketers.categories")}
      style={{ padding: 0 }}
    />
    <div>
      {Children.map(
        children,
        (input) =>
          input &&
          checkSubLabel(input.props.source, "custom3") && (
            <div
              key={input.props.source}
              className={`aor-input-${input.props.source}`}
              style={input.props.style}
            >
              <FormField
                input={input}
                resource={resource}
                record={record}
                basePath={basePath}
              />
            </div>
          )
      )}
    </div>
  </Card>
);

const checkNameField = (source) => {
  if (source === "social.instagram.id") {
    return "social.instagram.followers";
  } else if (source === "social.facebook.id") {
    return "social.facebook.followers";
  } else if (source === "social.twitter.id") {
    return "social.twitter.followers";
  } else if (source === "social.youtube.id") {
    return "social.youtube.followers";
  }
  return null;
};

const checkMessageField = (source) => {
  if (source === "social.instagram.id") {
    return "Such as 'ola.id' will be instagram.com/ola.id";
  } else if (source === "social.facebook.id") {
    return "Such as 'ola.id' will be facebook.com/ola.id";
  } else if (source === "social.twitter.id") {
    return "Such as 'ola.id' will be twitter.com/ola.id";
  } else if (source === "social.youtube.id") {
    return "Such as 'channel/ola.id' or 'user/ola.id' will be youtube.com/channel/ola.id or youtube.com/user/ola.id";
  }
  return null;
};

const linkToSocial = (source, props) => {
  const urlOla = "https://ola.id";
  if (source === "social.instagram.id") {
    return props.instagramId
      ? "https://instagram.com/" + props.instagramId
      : urlOla;
  } else if (source === "social.facebook.id") {
    return props.facebookId
      ? "https://facebook.com/" + props.facebookId
      : urlOla;
  } else if (source === "social.twitter.id") {
    return props.twitterId ? "https://twitter.com/" + props.twitterId : urlOla;
  } else if (source === "social.youtube.id") {
    return props.youtubeId ? "https://youtube.com/" + props.youtubeId : urlOla;
  }
  return urlOla;
};

const styles = {
  mediumIcon: {
    color: cyan500,
  },
  medium: {
    marginBottom: 16,
  },
};



// WEBPACK FOOTER //
// ./src/marketers/MarketerField.js